'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/es.symbol.unscopables.js
// module id = 733
// module chunks = 13